/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceAccountCredentialsForSaasOci extends models.ServiceAccountCredentialsBaseForSaas {
    constructor() {
        super();
        this.setDiscriminator("ServiceAccountCredentialsForSaasOci");
    }

    getFixupPrototypeFunction() { return ServiceAccountCredentialsForSaasOci.fixupPrototype; }

    static newInstance(model: Partial<ServiceAccountCredentialsForSaasOci>): ServiceAccountCredentialsForSaasOci {
        let obj = Object.assign(new ServiceAccountCredentialsForSaasOci(), model);
        ServiceAccountCredentialsForSaasOci.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceAccountCredentialsForSaasOci>): ServiceAccountCredentialsForSaasOci {
        if (!model) return null;
        return ServiceAccountCredentialsForSaasOci.newInstance(<ServiceAccountCredentialsForSaasOci> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceAccountCredentialsForSaasOci) {
        if (!obj) return;

        models.ServiceAccountCredentialsForSaasOci.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceAccountCredentialsForSaasOci): boolean {
        if (models.ServiceAccountCredentialsBaseForSaas.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ServiceAccountCredentialsForSaasOci.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Auth User Id. This is a required field.
     */
    user: string;

    /**
     * Key Fingerprint. This is a required field.
     */
    fingerprint: string;

    /**
     * Private Key. This is a required field.
     */
    private_key: string;

    /**
     * Tenancy Id. This is a required field.
     */
    tenancy_id: string;

    /**
     * Default Region. This is a required field.
     */
    region: string;

}
